import React, { useEffect, useState } from "react";
import PageHeader from "../../../components/shared/pageHeader/PageHeader";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { getCategory } from "../../../context/categories/action";
import { getStandsByCategory } from "../../../context/stands/action";
import { getEventsByCategory } from "../../../context/events/action";
import EventsList from "../../../components/events/list";
import StandsList from "../../../components/stands/list";
import { Stand } from "../../../data/interfaces";

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
interface Props {
}

const CategoryDetailView = ({ ...props }: Props) => {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------
  // Access to i18n instance that you may use to translate your content.
  const { t } = useTranslation();

  // Returns an object of key/value pairs of URL parameters that you may use to access match.params of the current <Route>.
  let { id } = useParams();

  // -----------------------------------------------------------------
  // N a v i g a t i o n   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------
  // Current category
  const [category, setCategory] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);

  // Events
  const [events, setEvents] = useState<any[]>([]);
  const [eventsLoading, setEventsLoading] = useState<boolean>(false);

  // Stands
  const [stands, setStands] = useState<any[]>([]);
  const [standsLoading, setStandsLoading] = useState<boolean>(false);

  // -----------------------------------------------------------------
  // R e f s  (DOM)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // u s e S e l e c t o r   m e t h o d s  (redux)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * Function to search by keywords in stands
   * @function
   * @async
   */
  const _searchStands = async (): Promise<any> => {
    setStandsLoading(true);
    try {
      let data: Stand[] = await getStandsByCategory(id);
      setStands(data);
    } catch (err) {
      // TODO:
    } finally {
      setStandsLoading(false);
    }
  };

  /**
   * Function to search by keywords in events
   * @function
   * @async
   */
  const _searchEvents = async (): Promise<any> => {
    setEventsLoading(true);
    try {
      let data: Event[] = await getEventsByCategory(id);
      setEvents(data);
    } catch (err) {
      // TODO:
    } finally {
      setEventsLoading(false);
    }
  };

  /**
   * Load current category by id
   * @function
   * @async
   */
  const loadCategory = async (): Promise<any> => {
    setLoading(true);
    try {
      const data = await getCategory(id);
      setCategory(data);

      _searchEvents();
      _searchStands();
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  // -----------------------------------------------------------------
  // R e n d e r   m e t h o d s
  // -----------------------------------------------------------------
  const renderStands = () => {
    return (
      <div className="stands">
        <h3>{t("pages.standsList.title")}</h3>

        <div className={"stands-list"}>
          {!!standsLoading && (
            <div className="list-loading">
              <i className="fas fa-spinner fa-spin"></i>
            </div>
          )}

          {!standsLoading && (!stands || !stands.length) && (
            <p>{t("pages.category.no_results.stands")}</p>
          )}

          {!standsLoading && stands && stands.length > 0 && <StandsList stands={stands}/>}
        </div>
      </div>
    );
  };

  const renderEvents = () => {
    return (
      <div className="events">
        <h3>{t("pages.eventsList.title")}</h3>
        <div className={`events-list ${events.length === 0 ? "no-data" : ""}`}>
          {!!eventsLoading && (
            <div className="list-loading">
              <i className="fas fa-spinner fa-spin"></i>
            </div>
          )}

          {!eventsLoading && (!events || !events.length) && (
            <p>{t("pages.category.no_results.events")}</p>
          )}

          {!eventsLoading && events && events.length > 0 && <EventsList events={events}/>}
        </div>
      </div>
    );
  };

  // -----------------------------------------------------------------
  // L i f e c y c l e
  // -----------------------------------------------------------------
  /**
   * This method is called the first time the component is mounted
   * @function
   */
  const init = (): void => {
    // init component
    console.log("[CategoryDetailView] init");
    loadCategory();
  };

  /**
   * This method is called when the component is unmounted
   * @function
   */
  const destroy = (): void => {
    // destroy component
    console.log("[CategoryDetailView] destroy");
  };

  // -----------------------------------------------------------------
  // u s e E f f e c t   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * This hook is called once when the component is mounted
   */
  useEffect(() => {
    init();

    return () => {
      destroy();
    };
  }, []);

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------
  return (
    <>
      <div className="page-content category-page">
        <div className="container">
          <PageHeader title={category?.name}/>

          <div className="results">
            {renderStands()}
            {renderEvents()}
          </div>
        </div>
      </div>
    </>
  );
};
export default CategoryDetailView;
